// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.view-item-header .title-section {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1 1;
}
.view-item-header .title-section h5 {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #333;
}
.view-item-header .title-section .title-input {
  font-size: 13px;
  font-weight: 600;
  padding: 4px 8px;
  height: 28px;
  border: none;
  border-bottom: 1px solid #333;
  border-radius: 0;
  background-color: transparent;
}
.view-item-header .title-section .title-input:focus {
  box-shadow: none;
  outline: none;
  border: none;
}
.view-item-header .title-section .title-action-btn {
  padding: 2px;
  color: #666;
  background: transparent;
  border: none;
}
.view-item-header .title-section .title-action-btn:hover {
  color: #003da5;
  background-color: rgba(0, 61, 165, 0.1);
}
.view-item-header .title-section .title-action-btn:focus {
  box-shadow: none;
}
.view-item-header .title-section .title-action-btn .pi {
  font-size: 11px;
}
.view-item-header .title-section .title-action-btn .pi-times {
  top: 2px;
  right: 0;
  position: relative;
}
.view-item-header .title-section .title-action-btn.title-action-btn-cancel {
  color: #d32f2f;
}
.view-item-header .title-section .title-action-btn.title-action-btn-cancel:hover {
  color: #d32f2f;
  background-color: rgba(211, 47, 47, 0.1);
}
.view-item-header .header-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}
.view-item-header .header-actions .header-icon-btn {
  padding: 2px;
  color: #666;
  background: transparent;
  border: none;
}
.view-item-header .header-actions .header-icon-btn:hover {
  color: #003da5;
  background-color: rgba(0, 61, 165, 0.1);
}
.view-item-header .header-actions .header-icon-btn:focus {
  box-shadow: none;
}
.view-item-header .header-actions .header-icon-btn .pi {
  font-size: 12px;
}

.p-confirm-dialog .p-dialog-footer {
  border-bottom-right-radius: 6px !important;
  border-bottom-left-radius: 6px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Tabs/DashboardTab/ViewHeader/ViewHeader.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;AACJ;AACI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AACN;AAEI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,6BAAA;AAAN;AAEM;EACE,gBAAA;EACA,aAAA;EACA,YAAA;AAAR;AAII;EACE,YAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;AAFN;AAIM;EACE,cAAA;EACA,uCAAA;AAFR;AAKM;EACE,gBAAA;AAHR;AAMM;EACE,eAAA;AAJR;AAOM;EACE,QAAA;EACA,QAAA;EACA,kBAAA;AALR;AAQM;EACE,cAAA;AANR;AAQQ;EACE,cAAA;EACA,wCAAA;AANV;AAYE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAVJ;AAaI;EACE,YAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;AAXN;AAaM;EACE,cAAA;EACA,uCAAA;AAXR;AAcM;EACE,gBAAA;AAZR;AAeM;EACE,eAAA;AAbR;;AAqBE;EACE,0CAAA;EACA,yCAAA;AAlBJ","sourcesContent":[".view-item-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n\n  .title-section {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex: 1;\n\n    h5 {\n      margin: 0;\n      font-size: 12px;\n      font-weight: 600;\n      color: #333;\n    }\n\n    .title-input {\n      font-size: 13px;\n      font-weight: 600;\n      padding: 4px 8px;\n      height: 28px;\n      border: none;\n      border-bottom: 1px solid #333;\n      border-radius: 0;\n      background-color: transparent;\n\n      &:focus {\n        box-shadow: none;\n        outline: none;\n        border: none;\n      }\n    }\n\n    .title-action-btn {\n      padding: 2px;\n      color: #666;\n      background: transparent;\n      border: none;\n\n      &:hover {\n        color: #003da5;\n        background-color: rgba(0, 61, 165, 0.1);\n      }\n\n      &:focus {\n        box-shadow: none;\n      }\n\n      .pi {\n        font-size: 11px;\n      }\n\n      .pi-times {\n        top: 2px;\n        right: 0;\n        position: relative;\n      }\n\n      &.title-action-btn-cancel {\n        color: #d32f2f;\n\n        &:hover {\n          color: #d32f2f;\n          background-color: rgba(211, 47, 47, 0.1);\n        }\n      }\n    }\n  }\n\n  .header-actions {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n\n\n    .header-icon-btn {\n      padding: 2px;\n      color: #666;\n      background: transparent;\n      border: none;\n\n      &:hover {\n        color: #003da5;\n        background-color: rgba(0, 61, 165, 0.1);\n      }\n\n      &:focus {\n        box-shadow: none;\n      }\n\n      .pi {\n        font-size: 12px;\n      }\n    }\n  }\n}\n\n// Confirm Dialog Styling\n.p-confirm-dialog {\n  .p-dialog-footer {\n    border-bottom-right-radius: 6px !important;\n    border-bottom-left-radius: 6px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
